import * as swcHelpers from '@swc/helpers';
import { isDefined } from '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getReadyReaderProductFeatures } from '../utils/product-feature-mappers/get-ready-reader-product-features.js';
import { mapServerToReadyReaderSpecifications } from '../specification-mappers/map-server-to-ready-reader-specifications.js';
import { mapServerToVariantBase } from './map-server-to-variant-base.js';
import { getSharedFrameVariantProps } from './shared/get-shared-frame-variant-props.js';

const mapServerToReadyReaderVariant = (serverProduct, slug, locale, priceSegmentChannelKey)=>{
    const { variants: serverVariants  } = serverProduct;
    if (!serverVariants || !serverVariants.length) {
        return;
    }
    const clientVariants = serverVariants.map((serverVariant)=>{
        const { variantTypeDetails  } = serverVariant;
        const { brand  } = serverProduct;
        const variantBase = mapServerToVariantBase(serverVariant, serverProduct, slug, locale, priceSegmentChannelKey);
        if (!variantBase || !variantTypeDetails.power) return;
        const readyReader = swcHelpers.objectSpread({}, variantBase, getSharedFrameVariantProps(variantTypeDetails), {
            variantType: 'ready-reader',
            specifications: mapServerToReadyReaderSpecifications(serverVariant, brand),
            facets: {
                power: variantTypeDetails.power
            },
            isVtoEnabled: false,
            isReservable: false,
            power: variantTypeDetails.power,
            productFeatures: getReadyReaderProductFeatures(variantTypeDetails)
        });
        return readyReader;
    });
    return clientVariants.filter(isDefined);
};

export { mapServerToReadyReaderVariant };
//# sourceMappingURL=map-server-to-ready-reader-variant.js.map
